import React, { useState } from "react";
import { Modal, Form, Input, Select, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { ApiURL } from "../services/apiConstants";
import { post } from "../services/services";
import { ErrorToast, SuccessToast } from "../widgets/AppToast";

const { TextArea } = Input;

const RequestFormModal2 = ({
  visible,
  onCancel,
  onSubmit,
  record_id,
  voyage_ids,
  setModalVisible,
  backtoedit,
  designation,
}) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const handleFinish = async (values) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", Number(voyage_ids));
      FORM_DATA.append("orb_part", "2");
      FORM_DATA.append("record_id", Number(record_id));
      FORM_DATA.append("description", values?.description);
      FORM_DATA.append("backtoedit", backtoedit);
      const response = await post(ApiURL?.notification_save_req, FORM_DATA);
      if (response?.status === true) {
        SuccessToast("Congratulations!", response?.message);
        navigate(`/edit-oil-record-log/${btoa(record_id)}`);
      } else {
        ErrorToast("Error", response?.message || "Something went wrong.");
      }
      setModalVisible(false);
    } catch (error) {
      console.error("Error in CREATE_REQUEST_EDIT_VARIFAY:", error);
      ErrorToast("Request Failed", "Could not complete the request. Please try again.");
    }

    form.resetFields();
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Submit Request"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        {designation !== "Captain" && (
          <>
            <strong>
              <i>
                You are editing a previously logged entry. As per ORB Part 2, this correction will
                be recorded with a Code ‘O’ entry, and the original content will be struck through.
                Do you wish to proceed?
              </i>
            </strong>
            <br />
          </>
        )}

        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Please enter a description" }]}
        >
          <TextArea rows={4} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RequestFormModal2;
